<div *ngIf="isLoading" class="loader-overlay">
  <p-progressSpinner
    styleClass="loader-spinner"
    strokeWidth="3"
    aria-label="Processando informações, aguarde!"
  ></p-progressSpinner>
</div>
